import EnbProdutos from '@/components/Theme01/Produtos/EnbProdutos'
import EnbItemView01 from '@/components/Theme01/Produtos/products/Produto01/EnbItemView01'
import EnbCheckoutView01 from '@/components/Theme01/Checkout/EnbCheckoutView01'
import CompletePurchase from '@/components/Theme01/Client/CompletePurchase'
import EnbPedidos01 from '@/components/Theme01/Pedidos/EnbPedidos01'
import PedidoView from '@/components/Theme01/Pedidos/PedidoView'
import EnbAccount01 from '@/components/Theme01/Account/EnbAccount01'
import EnbProfile from '@/components/Profile/EnbProfile'
import EnbLikes from '@/components/Theme01/Like/EnbLikes'
import EnbEditProfile from '@/components/Theme01/Client/EnbEditProfile'

export default [
  {
    path: '/login',
    name: 'Login',
    component: EnbProdutos,
    meta: { login: true }
  },
  {
    path: '/',
    name: 'Produtos01',
    component: EnbProdutos
  },
  {
    path: '/loja/:categ',
    name: 'Categorias',
    component: EnbProdutos
  },
  {
    path: '/:link',
    name: 'Produto',
    component: EnbItemView01
  },
  {
    path: '/loja/:categ/:link',
    name: 'Categoria Produto',
    component: EnbItemView01
  },
  {
    path: '/checkout',
    name: 'Carrinho',
    component: EnbCheckoutView01
  },
  {
    path: '/complete',
    name: 'Finalizar compra',
    component: CompletePurchase
  },
  {
    path: '/loja',
    name: 'Loja',
    component: EnbProdutos
  },
  {
    path: '/pedidos',
    name: 'Pedidos Loja',
    component: EnbPedidos01
  },
  {
    path: '/pedidos/view',
    name: 'Pedido View',
    component: PedidoView
  },
  {
    path: '/account',
    name: 'Minha conta',
    component: EnbAccount01
  },
  {
    path: '/profile',
    name: 'Pofile',
    component: EnbProfile
  },
  {
    path: '/likes',
    name: 'Likes',
    component: EnbLikes
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: EnbEditProfile
  }
]
